import { withVersions } from "v2/hocs/withVersions";
import { withGroupRowItem } from "../hocs/withGroupRowItem";
import GroupRowItemUIV1 from "./GroupRowItem/v1";
import GroupRowItemUIV2 from "./GroupRowItem/v2";

export const GroupRowItem = withVersions({
  v1: withGroupRowItem(GroupRowItemUIV1),
  v2: withGroupRowItem(GroupRowItemUIV2),
});

export default GroupRowItem;
